import { useContext } from 'react';

import { StepOne, StepTwo, StepThree, StepFour } from '../Steps';

import { LoadSavedQuotation } from '../components/LoadSavedQuotation';

import { QuotationInfoContext } from '../../shared/contexts/QuotationInfo';
import { StepFourFormProvider } from '../Steps/StepFour/contexts';
import { StepOneFormProvider } from '../../shared/contexts';
import { StepThreeFormProvider } from '../Steps/StepThree/contexts';
import { StepTwoFormProvider } from '../Steps/StepTwo/contexts';

import { WizardDataFormProvider } from './contexts/WizardDataForm';

import { QuotationStep } from '../../shared/interfaces';
import { LoadRenewalQuotation } from '../components/LoadRenewalQuotation';

export const WizardTheftInsurance = () => {
  const { currentStep, loadingSavedQuotation, loadingRenewalQuotation } = useContext(QuotationInfoContext);

  const getStepComponent = () => {
    switch (currentStep) {
      case QuotationStep.ONE:
        return <StepOne />;
      case QuotationStep.TWO:
        return <StepTwo />;
      case QuotationStep.THREE:
        return <StepThree />;
      case QuotationStep.FOUR:
        return <StepFour />;
      default:
        break;
    }
  };

  return (
      <StepOneFormProvider>
        <WizardDataFormProvider>
          <StepTwoFormProvider>
            <StepThreeFormProvider>
              <StepFourFormProvider> 
                { loadingRenewalQuotation ? <LoadRenewalQuotation /> : loadingSavedQuotation ? <LoadSavedQuotation /> : getStepComponent() }
              </StepFourFormProvider>
            </StepThreeFormProvider>
          </StepTwoFormProvider> 
        </WizardDataFormProvider>
      </StepOneFormProvider>
  );
};
